import { useEffect, useState } from 'react'
import { useAuthStore } from '@/stores/authStore'

/**
 * Zustand persist 복원 완료 여부.
 *
 * authStore 는 `skipHydration: true` 로 설정되어 있고 entry-client.tsx 가
 * `setTimeout(0)` 이후에 `persist.rehydrate()` 를 호출하므로, 첫 렌더 시점엔
 * 복원 전이라 `isAuthenticated=false` 로 잘못 판정될 수 있다. 인증 상태에
 * 따라 라우팅 분기를 하는 컴포넌트는 이 훅으로 복원 완료 전까지 판단을
 * 유보해야 한다.
 *
 * 사용 예:
 * ```tsx
 * const hydrated = useAuthHydrated()
 * if (!hydrated) return null
 * // 이후 isAuthenticated 를 신뢰해도 안전
 * ```
 */
export function useAuthHydrated(): boolean {
  const [hydrated, setHydrated] = useState<boolean>(() =>
    typeof window !== 'undefined' && useAuthStore.persist.hasHydrated()
  )
  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      setHydrated(true)
      return
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => setHydrated(true))
    return unsub
  }, [])
  return hydrated
}
